/** Envío AP-2 · reglas puras del editor de planes de subida (Admin › Subidas). */
export const KINDS = [
  { key: 'image_mb', label: 'Imagen' },
  { key: 'video_mb', label: 'Video' },
  { key: 'audio_mb', label: 'Audio' },
];
const ID_RE = /^[a-z0-9_-]{1,32}$/;

export function slugify(text) {
  return String(text || '')
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .toLowerCase().replace(/[^a-z0-9_-]+/g, '-').replace(/^-+|-+$/g, '')
    .slice(0, 32);
}

export function toRows(config) {
  const plans = config?.plans || {};
  return Object.entries(plans).map(([id, p]) => ({
    id, isNew: false, label: p.label || id,
    image_mb: p.image_mb, video_mb: p.video_mb, audio_mb: p.audio_mb,
  }));
}

export function newRow(rows) {
  let n = rows.length + 1;
  let id = `plan-${n}`;
  const taken = new Set(rows.map((r) => r.id));
  while (taken.has(id)) { n += 1; id = `plan-${n}`; }
  return { id, isNew: true, label: '', image_mb: 50, video_mb: 100, audio_mb: 50 };
}

/** Devuelve la lista de errores en español (vacía si está todo bien). */
export function validate(rows, defaultPlan, ceilingMb) {
  const errors = [];
  if (!rows.length) errors.push('Tiene que haber al menos un plan.');
  const seen = new Set();
  rows.forEach((r) => {
    const name = r.label || r.id;
    if (!ID_RE.test(r.id)) errors.push(`«${name}»: el identificador sólo admite minúsculas, números, - y _.`);
    if (seen.has(r.id)) errors.push(`El identificador «${r.id}» está repetido.`);
    seen.add(r.id);
    KINDS.forEach(({ key, label }) => {
      const v = Number(r[key]);
      if (!Number.isInteger(v) || v < 1 || v > ceilingMb) {
        errors.push(`«${name}»: ${label} tiene que ser un número entero entre 1 y ${ceilingMb} MB.`);
      }
    });
  });
  if (rows.length && !rows.some((r) => r.id === defaultPlan)) {
    errors.push('Elegí cuál es el plan por defecto.');
  }
  return errors;
}

export function toConfig(rows, defaultPlan, directUpload) {
  const plans = {};
  rows.forEach((r) => {
    plans[r.id] = {
      label: (r.label || r.id).trim(),
      image_mb: Number(r.image_mb), video_mb: Number(r.video_mb), audio_mb: Number(r.audio_mb),
    };
  });
  return { default_plan: defaultPlan, direct_upload: !!directUpload, plans };
}
